import React from 'react'

const EvaluationOptions = ({varCheckData,varIndex,onChangeOptionHandler}) => {

  return (
    <div className="form-group">
      <div className="mdt-check-label">{varCheckData.vtc_checkpoint}</div>
      <p>진단</p>
      <div className="check-group horizontal">
        <div className="checkbox2" style={{width:"33%",textAlign:"center"}}>
          <input type="radio" name={'evl_score_'+varCheckData.vtc_idx} id={'evl_score_'+varCheckData.vtc_idx+'_1'} value={3} checked={varCheckData.evl_score===3} onChange={e=>onChangeOptionHandler(e,varIndex,varCheckData.vtc_idx)}/>
          <label htmlFor={'evl_score_'+varCheckData.vtc_idx+'_1'}>적극</label>
        </div>
        <div className="checkbox2" style={{width:"33%",textAlign:"center"}}>
          <input type="radio" name={'evl_score_'+varCheckData.vtc_idx} id={'evl_score_'+varCheckData.vtc_idx+'_2'} value={2} checked={varCheckData.evl_score===2} onChange={e=>onChangeOptionHandler(e,varIndex,varCheckData.vtc_idx)}/>
          <label htmlFor={'evl_score_'+varCheckData.vtc_idx+'_2'}>평균</label>
        </div>
        <div className="checkbox2" style={{width:"33%",textAlign:"center"}}>
          <input type="radio" name={'evl_score_'+varCheckData.vtc_idx} id={'evl_score_'+varCheckData.vtc_idx+'_3'} value={1} checked={varCheckData.evl_score===1} onChange={e=>onChangeOptionHandler(e,varIndex,varCheckData.vtc_idx)}/>
          <label htmlFor={'evl_score_'+varCheckData.vtc_idx+'_3'}>소극</label>
        </div>
      </div>
    </div>
  )
}
export default EvaluationOptions;